import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {LocationStatus} from '@emm/core/models/location-status.model';
import {standardRetry} from '@emm/core/util/rx.util';


@Injectable({
    providedIn: 'root',
})
export class LocationStatusService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    public getAllStatuses(): Observable<LocationStatus[]> {
        return this.http
            .get<any>(this.apiUrl + '/location-status?includeChildren=true')
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }


    public getEmergencyStatuses(): Observable<LocationStatus[]> {
        return this.http
            .get<any>(this.apiUrl + '/location-status/findByType?type=EMERGENCY')
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }



    public getOtherStatuses(): Observable<any> {
        return this.http
            .get<any>(this.apiUrl + '/location-status/findByTypeNot?type=EMERGENCY')
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }



    public createLocationStatus(locationStatus): Observable<any> {
        return this.http
            .post(this.apiUrl + '/location-status', locationStatus, { responseType: 'text' })
            .pipe(standardRetry());
    }



    public updateStatusMessage(statusTag: string, statusMessage: string, active: boolean, subType: string): Observable<any> {
        return this.http
            .put(this.apiUrl + '/location-status/' + statusTag, { statusMessage, active }, { responseType: 'text' })
            .pipe(standardRetry());
    }

    public updateStatus(statusTag: string, active: boolean){
        return this.http
            .put(this.apiUrl + '/location-status/status/' + statusTag, { active }, { responseType: 'text' })
            .pipe(standardRetry());
    }



    public downloadLocationStatus(statuses): Observable<any> {
        let params = new HttpParams();
        statuses.forEach(status => { params = params.set(status.status, status.value); });
        return this.http
            .get<any>(this.apiUrl + '/locations/status/report', {params});
    }



}
